import { initUI, onAuthStateChanged } from "../../lib/firebase";
import { mapActions, mapMutations } from "vuex";

import FontumiCellphone from "../../assets/fontumi-cellphone.png";

import JannaMazdaLogo from "../../assets/jannamazdalogo.jpg";
import FordLogo from "../../assets/fordlogo.jpg";

export default {
  name: "Auth",

  data: () => ({
    FontumiCellphone,
    FordLogo,
    JannaMazdaLogo
  }),

  metaInfo: {
    title: "Iniciar sesión"
  },

  methods: {
    ...mapActions(["findProject"]),
    ...mapMutations(["setUser"])
  },

  mounted() {
    onAuthStateChanged(async user => {
      if (user) {
        const { displayName, email, photoURL, uid, phoneNumber } = user;

        this.setUser({
          displayName,
          email,
          uid,
          photoURL,
          phoneNumber
        });

        await this.findProject();

        this.$router.push(
          this.$route.query.to
            ? this.$route.query.to
            : {
                name: "home"
              }
        );
      }
    });

    initUI(this.$refs["firebaseui-auth-container"]);
  }
};
